import type { IIdName } from '@/interfaces/general/IIdName.ts';

export type PlantDetailsTab = 'charts' | 'contracts' | 'remit' | 'extraInfo';

interface IPlantDetailsTab extends IIdName {
    id: PlantDetailsTab;
}

export const PLANT_DETAILS_TABS: Array<IPlantDetailsTab> = [
    { id: 'charts', name: 'Charts' },
    { id: 'contracts', name: 'Contracts' },
    { id: 'remit', name: 'Remit' },
    { id: 'extraInfo', name: 'Extra Info' },
];
